import React from 'react';
import ProgressGraphContainer from './ProgressGraphContainer';

const ProgressGraphs = ({ graphsData, clientTrackObj, clientId }) => {
  return (
    <div className="graphs">
      {graphsData.calories && (
        <ProgressGraphContainer
          id="calories"
          title="Calories"
          xAxis="Day"
          yAxis={['Calories Taken']}
          data={graphsData.calories}
          showSwitchBtn={false}
          clientId={clientId}
        />
      )}
      {graphsData.carbs && (
        <ProgressGraphContainer
          id="carbs"
          xAxis="Day"
          yAxis={['Carbs Taken']}
          title="Carbs"
          data={graphsData.carbs}
          showSwitchBtn={false}
          clientId={clientId}
        />
      )}
      {graphsData.fats && (
        <ProgressGraphContainer
          id="fat"
          xAxis="Day"
          yAxis={['Fat Taken']}
          title="Fat"
          data={graphsData.fats}
          showSwitchBtn={false}
          clientId={clientId}
        />
      )}
      {graphsData.proteins && (
        <ProgressGraphContainer
          id="protein"
          xAxis="Day"
          yAxis={['Protein Taken']}
          title="Protein"
          data={graphsData.proteins}
          showSwitchBtn={false}
          clientId={clientId}
        />
      )}
      {graphsData.water && (
        <ProgressGraphContainer
          id="water"
          xAxis="Day"
          yAxis={['Water']}
          title="Water"
          data={graphsData.water}
          showSwitchBtn={false}
          clientId={clientId}
        />
      )}
      {graphsData.exercises && (
        <ProgressGraphContainer
          id="exercise"
          xAxis="Day"
          yAxis={['Exercise']}
          title="Exercise"
          data={graphsData.exercises}
          showSwitchBtn={false}
          clientId={clientId}
        />
      )}

      {graphsData.digestion && (
        <ProgressGraphContainer
          id="digestion"
          xAxis="Day"
          yAxis={['Digestion']}
          title="Digestion"
          data={graphsData.digestion}
          showSwitchBtn={true}
          isEnabled={clientTrackObj.digestion}
          trackKey={'digestion'}
          clientId={clientId}
        />
      )}
      {graphsData.craving && (
        <ProgressGraphContainer
          id="craving"
          xAxis="Day"
          yAxis={['Craving']}
          title="Craving"
          data={graphsData.craving}
          showSwitchBtn={true}
          isEnabled={clientTrackObj.craving}
          trackKey={'craving'}
          clientId={clientId}
        />
      )}
      {graphsData.hunger && (
        <ProgressGraphContainer
          id="hunger"
          xAxis="Day"
          yAxis={['Hunger']}
          title="Hunger"
          data={graphsData.hunger}
          showSwitchBtn={true}
          isEnabled={clientTrackObj.hunger}
          trackKey={'hunger'}
          clientId={clientId}
        />
      )}
      {graphsData.energy && (
        <ProgressGraphContainer
          id="energy"
          xAxis="Day"
          yAxis={['Energy']}
          title="Energy"
          data={graphsData.energy}
          showSwitchBtn={true}
          isEnabled={clientTrackObj.energy}
          trackKey={'energy'}
          clientId={clientId}
        />
      )}
      {graphsData.sleep && (
        <ProgressGraphContainer
          id="sleep"
          xAxis="Day"
          yAxis={['Sleep']}
          title="Sleep"
          data={graphsData.sleep}
          showSwitchBtn={true}
          isEnabled={clientTrackObj.sleep}
          trackKey={'sleep'}
          clientId={clientId}
        />
      )}
      {graphsData.weight && (
        <ProgressGraphContainer
          id="weight"
          xAxis="Day"
          yAxis={['Weight']}
          title="Weight"
          data={graphsData.weight}
          showSwitchBtn={true}
          isEnabled={clientTrackObj.weight}
          trackKey={'weight'}
          clientId={clientId}
        />
      )}
      {graphsData.steps && (
        <ProgressGraphContainer
          id="steps"
          xAxis="Day"
          yAxis={['Steps']}
          title="Steps"
          data={graphsData.steps}
          showSwitchBtn={true}
          isEnabled={clientTrackObj.steps}
          trackKey={'steps'}
          clientId={clientId}
        />
      )}
      {graphsData.heartRate && (
        <ProgressGraphContainer
          id="resting_heart_rate"
          xAxis="Day"
          yAxis={['Resting Heart Rate']}
          title="Resting Heart Rate"
          data={graphsData.heartRate}
          showSwitchBtn={true}
          isEnabled={clientTrackObj.resting_heart_rate}
          trackKey={'resting_heart_rate'}
          clientId={clientId}
        />
      )}
      {graphsData.bloodPressure && (
        <ProgressGraphContainer
          id="blood_pressure"
          xAxis="Day"
          yAxis={['diastolic_blood_pressure', 'systolic_blood_pressure']}
          title="Blood Pressure"
          data={graphsData.bloodPressure}
          showSwitchBtn={true}
          isEnabled={clientTrackObj.blood_pressure}
          trackKey={'blood_pressure'}
          clientId={clientId}
        />
      )}
      {graphsData.adherence && (
        <ProgressGraphContainer
          id="adherence"
          xAxis="Day"
          yAxis={['adherence']}
          title="Adherence"
          data={graphsData.adherence}
          showSwitchBtn={true}
          isEnabled={clientTrackObj.adherence}
          trackKey={'adherence'}
          clientId={clientId}
        />
      )}
    </div>
  );
};

export default ProgressGraphs;
